module.exports = __webpack_public_path__ + "img/honey-pot.47115e62.png";